var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"LeftBottom"}},[_c('dv-border-box-13',[_c('HeaderTitle',{attrs:{"title":"仓储分布"}}),_c('LeftBottomEarch')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }